<template>
  <div>
    <!-- Header -->
    <div class="row">
      <div class="col-md-4">
        <h3>Withdraw Roll</h3>

        <div class="form-group">
          <v-select
            class="fabric-selector"
            label="production_name"
            placeholder="Select a Fabric"
            @input="setSelected"
            :value="selectedFabric"
            :options="allFabrics"
          >
          </v-select>
        </div>
      </div>
      <div class="col-md-2">
        <button class="btn btn-primary mt-53" @click="showWithdrawLogsModal">
          <i class="fa fa-eye" aria-hidden="true"></i>
          View Withdraw Logs
        </button>
      </div>

      <!-- Fabric Preview -->
      <div
        class="selected-fabric-preview col-md-6 text-right sm-none"
        v-if="selectedFabric"
      >
        <h4 class="fabric-no">{{ $Fabric.getCode(selectedFabric.id) }}</h4>
        <h3 class="text-bold fabric-name">{{ selectedFabric.fabric_name }}</h3>
        <img v-bind:src="selectedFabric.image" class="img" />
      </div>
      <!-- Fabric Preview -->
    </div>
    <!-- Header -->

    <div class="row" v-if="selectedFabric">
      <div class="col-sm-12">
        <!-- Rolls: Currently In Use -->
        <div class="grid simple shadow bg-white">
          <div class="grid-title no-border">
            <h4>Rolls currently in use</h4>
            <label class="total-rolls label label-info pull-right">{{
              tableRows.in_use.length
            }}</label>
          </div>
          <div class="grid-body no-border">
            <div class="table-responsive">
              <vue-good-table
                styleClass="table table-hover table-condensed"
                :rows="tableRows.in_use"
                :columns="tableColumns"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'percentage_used'">
                    <Progress
                      :val="props.row.percentage_used"
                      type="warning"
                      :label="
                        round(props.row.length_remaining) +
                        ' ' +
                        props.row.roll_unit +
                        ' / ' +
                        round(props.row.length) +
                        ' ' +
                        props.row.roll_unit +
                        ' (length used = ' +
                        round(props.row.length_used) +
                        ' ' +
                        props.row.roll_unit +
                        ')'
                      "
                    ></Progress>
                  </span>
                  <span v-else-if="props.column.field == 'withdrawal_date'">
                    <span
                      v-if="props.row.withdrawal_date == null"
                      class="text-center"
                    >
                      <i
                        class="fa fa-minus-circle text-error none-date"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </span>
                  <span
                    v-else-if="props.column.field == 'empty_date'"
                    class="text-center"
                  >
                    <span v-if="props.row.empty_date == null">
                      <i
                        class="fa fa-minus-circle text-error none-date"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </span>
                  <span
                    v-else-if="props.column.field == 'action_id'"
                    class="text-center"
                  >
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
        <!-- Rolls: Currently In Use -->

        <!-- Rolls: In Warehouse (Upstairs) -->
        <div class="grid simple shadow bg-white">
          <div class="grid-title no-border">
            <h4 class="semi-bold">Rolls in warehouse (UPSTAIRS)</h4>
            <label class="total-rolls label label-info pull-right">{{
              tableRows.warehouse.upstairs.length
            }}</label>
          </div>
          <div class="grid-body no-border">
            <div class="table-responsive">
              <vue-good-table
                styleClass="table table-hover table-condensed"
                :rows="tableRows.warehouse.upstairs"
                :select-options="{ enabled: true }"
                @on-selected-rows-change="selectionChanged"
                :columns="tableColumns"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'percentage_used'">
                    <Progress
                      :val="props.row.percentage_used"
                      :label="
                        round(props.row.length_remaining) +
                        ' ' +
                        props.row.roll_unit +
                        ' / ' +
                        round(props.row.length) +
                        ' ' +
                        props.row.roll_unit +
                        ' (length used = ' +
                        round(props.row.length_used) +
                        ' ' +
                        props.row.roll_unit +
                        ')'
                      "
                    ></Progress>
                  </span>
                  <span v-else-if="props.column.field == 'withdrawal_date'">
                    <span
                      v-if="props.row.withdrawal_date == null"
                      class="text-center"
                    >
                      <i
                        class="fa fa-minus-circle text-error none-date"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </span>
                  <span
                    v-else-if="props.column.field == 'empty_date'"
                    class="text-center"
                  >
                    <span v-if="props.row.empty_date == null">
                      <i
                        class="fa fa-minus-circle text-error none-date"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </span>
                  <span
                    v-else-if="props.column.field == 'action_id'"
                    class="text-center"
                  >
                    <button
                      @click.stop="
                        withdrawRoll(props.row.roll_id, props.row.roll_code)
                      "
                      class="btn btn-primary"
                      v-if="!isReadOnlyUser"
                    >
                      Withdraw
                    </button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
                <div slot="selected-row-actions">
                  <button
                    class="btn btn-success"
                    @click="moveToWarehouse('downstairs')"
                    v-if="!isReadOnlyUser"
                  >
                    <i class="fa fa-download" aria-hidden="true"></i>
                    Move to Downstairs
                  </button>
                  <button
                    class="btn btn-danger"
                    @click.stop="moveToEmpty()"
                    v-if="!isReadOnlyUser"
                  >
                    Move to Empty
                  </button>
                </div>
              </vue-good-table>
            </div>
          </div>
        </div>
        <!-- Rolls: In Warehouse (Upstairs) -->

        <!-- Rolls: In Warehouse (Downstairs) -->
        <div class="grid simple shadow bg-white">
          <div class="grid-title no-border">
            <h4 class="semi-bold">Rolls in warehouse (DOWNSTAIRS)</h4>
            <label class="total-rolls label label-info pull-right">{{
              tableRows.warehouse.downstairs.length
            }}</label>
          </div>
          <div class="grid-body no-border">
            <div class="table-responsive">
              <vue-good-table
                styleClass="table table-hover table-condensed"
                :rows="tableRows.warehouse.downstairs"
                :select-options="{ enabled: true }"
                @on-selected-rows-change="selectionChanged"
                :columns="tableColumns"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'percentage_used'">
                    <Progress
                      :val="props.row.percentage_used"
                      :label="
                        round(props.row.length_remaining) +
                        ' ' +
                        props.row.roll_unit +
                        ' / ' +
                        round(props.row.length) +
                        ' ' +
                        props.row.roll_unit +
                        ' (length used = ' +
                        round(props.row.length_used) +
                        ' ' +
                        props.row.roll_unit +
                        ')'
                      "
                    ></Progress>
                  </span>
                  <span v-else-if="props.column.field == 'withdrawal_date'">
                    <span
                      v-if="props.row.withdrawal_date == null"
                      class="text-center"
                    >
                      <i
                        class="fa fa-minus-circle text-error none-date"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </span>
                  <span
                    v-else-if="props.column.field == 'empty_date'"
                    class="text-center"
                  >
                    <span v-if="props.row.empty_date == null">
                      <i
                        class="fa fa-minus-circle text-error none-date"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </span>
                  <span
                    v-else-if="props.column.field == 'action_id'"
                    class="text-center"
                  >
                    <button
                      @click.stop="
                        withdrawRoll(props.row.roll_id, props.row.roll_code)
                      "
                      class="btn btn-primary"
                      v-if="!isReadOnlyUser"
                    >
                      Withdraw
                    </button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
                <div slot="selected-row-actions">
                  <button
                    class="btn btn-success"
                    @click="moveToWarehouse('upstairs')"
                    v-if="!isReadOnlyUser"
                  >
                    <i class="fa fa-upload" aria-hidden="true"></i>
                    Move to Upstairs
                  </button>
                  <button
                    class="btn btn-danger"
                    @click.stop="moveToEmpty()"
                    v-if="!isReadOnlyUser"
                  >
                    Move to Empty
                  </button>
                </div>
              </vue-good-table>
            </div>
          </div>
        </div>
        <!-- Rolls: In Warehouse (Downstairs) -->

        <!-- Rolls: In Warehouse (Empty Rolls) -->
        <div class="grid simple shadow bg-white">
          <div class="grid-title no-border">
            <h4>Empty Rolls</h4>
            <label class="total-rolls label label-info pull-right">{{
              tableRows.empty.length
            }}</label>
          </div>
          <div class="grid-body no-border">
            <div class="table-responsive">
              <vue-good-table
                styleClass="table table-hover table-condensed"
                :rows="tableRows.empty"
                :select-options="{ enabled: true }"
                @on-selected-rows-change="selectionChanged"
                :columns="tableColumns"
                :pagination-options="{
                  enabled: true,
                  mode: 'pages',
                }"
                :sort-options="{
                  enabled: true,
                  initialSortBy: { field: 'empty_date', type: 'desc' },
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'percentage_used'">
                    <Progress
                      :val="props.row.percentage_used"
                      type="danger"
                      :label="
                        round(props.row.length_remaining) +
                        ' ' +
                        props.row.roll_unit +
                        ' / ' +
                        round(props.row.length) +
                        ' ' +
                        props.row.roll_unit +
                        ' (length used = ' +
                        round(props.row.length_used) +
                        ' ' +
                        props.row.roll_unit +
                        ')'
                      "
                    ></Progress>
                  </span>
                  <span v-else-if="props.column.field == 'withdrawal_date'">
                    <span
                      v-if="props.row.withdrawal_date == null"
                      class="text-center"
                    >
                      <i
                        class="fa fa-minus-circle text-error none-date"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </span>
                  <span
                    v-else-if="props.column.field == 'empty_date'"
                    class="text-center"
                  >
                    <span v-if="props.row.empty_date == null">
                      <i
                        class="fa fa-minus-circle text-error none-date"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </span>
                  <span
                    v-else-if="props.column.field == 'action_id'"
                    class="text-center"
                  >
                    <button
                      class="btn btn-danger"
                      @click.stop="moveToInUse(props.row.roll_id)"
                      v-if="!isReadOnlyUser"
                    >
                      Move to In Use
                    </button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
                <div slot="selected-row-actions">
                  <button
                    class="btn btn-success"
                    @click="moveToWarehouse('upstairs')"
                    v-if="!isReadOnlyUser"
                  >
                    <i class="fa fa-upload" aria-hidden="true"></i>
                    Move to Warehouse (Upstairs)
                  </button>
                  <button
                    class="btn btn-success"
                    @click="moveToWarehouse('downstairs')"
                    v-if="!isReadOnlyUser"
                  >
                    <i class="fa fa-upload" aria-hidden="true"></i>
                    Move to Warehouse (Downstairs)
                  </button>
                </div>
              </vue-good-table>
            </div>
          </div>
        </div>
        <!-- Rolls: In Warehouse (Empty Rolls) -->
      </div>
    </div>

    <div v-if="!selectedFabric">
      <h4>Please select a Fabric from the combo box above to continue...</h4>
    </div>

    <withdraw-logs :allFabrics="allFabrics" />
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import Progress from "@/pages/Tools/progress-bar.vue";
import Swal from "sweetalert2";
import * as $ from "jquery";
import "select2/dist/js/select2.min.js";
import WithdrawLogs from "./components/WithdrawLogsModal";

export default {
  components: {
    VueGoodTable,
    Progress,
    WithdrawLogs,
  },
  data() {
    return {
      isReadOnlyUser: false,
      selectedFabric: null,
      allFabrics: [],
      tableColumns: [
        {
          label: "Roll Code #",
          field: "roll_code",
          width: "30%",
        },
        {
          label: "Stock",
          field: "percentage_used",
          width: "20%",
          type: "percentage",
          thClass: "text-left",
        },
        {
          label: "Withdraw Date",
          field: "withdrawal_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd",
          dateOutputFormat: "d-MMM-yyyy",
          tdClass: "text-center",
          thClass: "text-center",
          width: "15%",
        },
        {
          label: "Empty Date",
          field: "empty_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd",
          dateOutputFormat: "d-MMM-yyyy",
          tdClass: "text-center",
          thClass: "text-center",
          width: "15%",
          sortFn: this.dateSortFn,
        },
        {
          label: "",
          field: "action_id",
          tdClass: "text-right",
        },
      ],
      tableRows: {
        warehouse: {
          upstairs: [],
          downstairs: [],
        },
        in_use: [],
        empty: [],
      },
      rowSelection: [],
    };
  },
  async mounted() {
    let fabricId = this.$route.params.fabric_id;
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    await this.getFabrics();
    this.setSelectedFromFabricId(fabricId);
  },
  methods: {
    showWithdrawLogsModal() {
      show_modal("#withdraw-log-modal");
    },

    round(value) {
      return Number(Math.round(value + "e" + 2) + "e-" + 2);
    },

    dateSortFn(date0, date1) {
      let t0 = moment(date0).unix();
      let t1 = moment(date1).unix();
      return t0 < t1 ? -1 : t0 > t1 ? 1 : 0;
    },

    async getFabrics() {
      let results = await axios({
        method: "get",
        url: "/v2/fabrics?as_dropdown=1",
      });
      this.allFabrics = results.data.data.collection;
    },

    async getRollDataForFabric(fabricId) {
      try {
        let results = await axios({
          method: "get",
          url: "/v2/fabrics/withdrawal/" + fabricId,
        });
        this.tableRows = results.data.data.rolls;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },

    setSelected(option) {
      option.rolls = [];
      this.selectedFabric = option;
      this.getRollDataForFabric(option.id);
    },

    setSelectedFromFabricId(fabricId) {
      for (var fabric in this.allFabrics) {
        if (this.allFabrics[fabric].id == fabricId) {
          this.setSelected(this.allFabrics[fabric]);
        }
      }
    },

    async showConfirmation(rollCode) {
      var message = "Please confirm you want to withdraw roll: " + rollCode;
      var title = "Are You Sure?";
      var type = "warning";
      if (
        this.tableRows.in_use.length > 0 &&
        this.tableRows.in_use[0].length_remaining > 0
      ) {
        let currentRoll = this.tableRows.in_use[0];
        let lengthRemaining = currentRoll.length - currentRoll.length_used;
        var message = `<h2 class="text-bold">Old Roll Not Empty</h2>
                        <h2>Still ${ezy.comma(lengthRemaining)} m Left</h2>
                        <div class="text-left" style="
                            font-size: 12px;
                            margin-top: 57px;
                        ">
                            Name Old roll : ${currentRoll.roll_code} <br>
                            Name New roll : ${rollCode}
                        </div>`;
        var title = "<strong>Call Renke</strong>";
        var type = "error";
      }

      let res = await Swal.fire({
        title: title,
        type: type,
        input: "password",
        html: message,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confrimButtonColor: "#d33",
        confirmButtonText: "Withdraw",
        showConfirmButton: true,
        inputValidator: (value) => {
          if (!value || value != "NC2011") {
            return "Invalid Password";
          }
        },
      });
      return res.value ? true : false;
    },

    async withdrawRoll(rollId, rollCode) {
      let confirmation = await this.showConfirmation(rollCode);
      if (confirmation) {
        try {
          let results = await axios({
            method: "post",
            url:
              "/v2/fabrics/withdrawal/" + this.selectedFabric.id + "/withdraw",
            params: {
              rollId: rollId,
              inUseRoll: this.tableRows.in_use[0],
            },
          });
          if (results.status) {
            this.getRollDataForFabric(this.selectedFabric.id);
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    selectionChanged(params) {
      this.rowSelection = params.selectedRows;
    },

    async moveToInUse(roll_id) {
      let confirm = await ezy.confirm(
        "Are you sure to move this roll into currently in use?"
      );
      if (confirm) {
        let fabric_id = this.selectedFabric.id;
        try {
          let res = await axios.post("/v2/fabrics/withdrawal/move", {
            type_of_move: "in_use",
            roll_id,
            fabric_id,
          });
          if (res) {
            this.getRollDataForFabric(this.selectedFabric.id);
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    async moveToEmpty() {
      let confirm = await ezy.confirm(
        "Are you sure to move selected rolls into empty?"
      );
      if (confirm) {
        let rollIds = [];
        this.rowSelection.forEach((val) => {
          rollIds.push(val.roll_id);
        });

        try {
          let res = await axios.post("/v2/fabrics/withdrawal/move", {
            type_of_move: "empty",
            roll_ids: rollIds,
          });
          if (res) {
            this.getRollDataForFabric(this.selectedFabric.id);
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    async moveToWarehouse(type) {
      let typeText = type === "upstairs" ? "upstairs" : "downstairs";
      let confirm = await ezy.confirm(
        `Are you sure to move selected rolls into ${typeText}?`
      );
      if (confirm) {
        let rollIds = [];
        this.rowSelection.forEach((val) => {
          rollIds.push(val.roll_id);
        });

        try {
          let res = await axios.post("/v2/fabrics/withdrawal/move", {
            type_of_move: "warehouse_" + type,
            roll_ids: rollIds,
          });
          if (res) {
            this.getRollDataForFabric(this.selectedFabric.id);
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },
  },
};
</script>

<style scoped>
@import "~select2/dist/css/select2.min.css";
@import "~vue-select/dist/vue-select.css";
@import "~vue-good-table/dist/vue-good-table.css";
@import "~vuejs-dialog/dist/vuejs-dialog.min.css";

.fabric-selector {
  background: #fff;
}
.fs-10 {
  font-size: 10px !important;
}

.selected-fabric-preview {
  margin-top: 15px;
}

.form-control {
  border-radius: 0px 10px 10px 0px;
  height: 38px;
}

.input-group-addon {
  height: 38px !important;
  border-radius: 10px 0px 0px 10px !important;
}

.img {
  height: 80px;
  width: 80px;
  border-radius: 5px;
}

.search-input {
  width: 250px;
}

.select2-container .select2-selection--single {
  border-radius: 10px !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
}

.table td {
  vertical-align: middle !important;
}

.fabric-no {
  position: absolute;
  right: 110px;
}

.fabric-name {
  top: 25px;
  position: absolute;
  right: 110px;
}

.none-date {
  font-size: 18px;
}

.table-container {
  height: 200px;
  overflow: hidden;
}

.table-container:hover {
  overflow: auto;
}

.total-rolls {
  font-size: 20px;
}

.tiles-title {
  margin-top: -15px;
  margin-bottom: 20px;
  margin-left: 15px;
}
.mt-53 {
  margin-top: 53px;
}
</style>
